import { Record } from 'immutable';
import { makeReducer, match } from 'web-app/util/redux';
import * as Actions from './actions';
export class EmployeeCheckOutState extends Record({
    isCheckingOut: false,
}) {
}
export default makeReducer([
    match(Actions.checkOutEmployee, state => state.merge({
        isCheckingOut: true,
    })),
    match(Actions.checkOutEmployeeSuccess, state => state.merge({
        isCheckingOut: false,
    })),
    match(Actions.checkOutEmployeeFailed, state => state.merge({
        isCheckingOut: false,
    })),
], new EmployeeCheckOutState());
